module.exports = "data:text/x-markdown;base64,TW9zdCBvZiBFdGhlcm5hdXQncyBsZXZlbHMgdHJ5IHRvIGV4cG9zZSAoaW4gYW4gb3ZlcnNpbXBsaWVmaWVkIGZvcm0gb2YgY291cnNlKSBzb21ldGhpbmcgdGhhdCBhY3R1YWxseSBoYXBwZW5kLiBBIHJlYWwgaGFjayBvciBhIHJlYWwgYnVnLgoKSW4gdGhpcyBjYXNlLCBzZWU6CltLaW5nIG9mIHRoZSBFdGhlcl0oaHR0cHM6Ly93d3cua2luZ29mdGhlZXRoZXIuY29tL3Rocm9uZXMva2luZ29mdGhlZXRoZXIvaW5kZXguaHRtbCkKYW5kCltLaW5nIG9mIHRoZSBFdGhlciBQb3N0bW9ydGVtXShodHRwOi8vd3d3LmtpbmdvZnRoZWV0aGVyLmNvbS9wb3N0bW9ydGVtLmh0bWwp"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/king_complete.md
// module id = 1388
// module chunks = 0